import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiClientConfig} from '../api-client-config';
import {ColumnsConfigurationsType} from '@pt/pt-models';
import {Observable} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class ColumnConfigurationService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    private httpClient: HttpClient) {
    this.endpoint = this.config.endPoint + '/api/org/columns-configurations/';
  }

  resetColumns(type: ColumnsConfigurationsType): Observable<void> {
    const url = this.endpoint + `${type}/reset`;
    return this.httpClient.post<void>(url, {});
  }

}
